import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton-loader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  template: `
    @if (isLoading) {
      <div
        class="skeleton-loader"
        [style.background-color]="loaderBackgroundColor"
        [style.width]="loaderWidth"
        [style.height]="loaderHeight"
        ngProjectAs="[app-skeleton-loader]"></div>
    }
  `,
  styles: [
    `
      .skeleton-loader {
        animation: skeleton-loading 1s linear infinite alternate;
      }

      @keyframes skeleton-loading {
        0% {
          background-color: hsl(200, 20%, 80%);
        }
        100% {
          background-color: hsl(200, 20%, 95%);
        }
      }
    `
  ]
})
export class SkeletonLoaderComponent {
  @Input() isLoading = true;
  @Input() loaderBackgroundColor = '#f7f7f7';
  @Input() loaderWidth = '100%';
  @Input() loaderHeight = '100%';
}
